angular.module('dnecom')
    .directive('datatableColumnsSwitch', ['$rootScope', 'StorageBag', function ($rootScope, StorageBag) {
        var BAG_KEY = 'es-ui-columns';

        var initialized = false;

        var getStorage = function () {
            return StorageBag.get(BAG_KEY)
        };

        var setStorage = function (data) {
            StorageBag.put(BAG_KEY, data)
        };

        var initLocalStorage = function (tableId, columns) {
            if (_.isUndefined(getStorage()) || _.isNull(getStorage())) {
                setStorage({});
            }

            var storage = getStorage();

            if (_.isUndefined(storage[tableId])) {
                storage[tableId] = {};

                angular.forEach(columns, function(name, index) {
                    storage[tableId][index] = 1;
                });

                setStorage(storage);
            }
        };

        return {
            type: 'EA',
            transclude: false,
            replace: true,
            template:
                '<span class="column-switch-container {{ class }}">'
                    + '<button class="btn btn-default" ng-click="toggleColumnsList($event)" uib-tooltip="Toggle columns visibility"><i class="fa fa-columns"></i></button>'
                    + '<div class="btn-group-vertical" ng-show="isColumnsListVisible()" ng-click="onPopupClick($event)">'
                        + '<button class="btn btn-default" ng-repeat="(index, name) in columns" ng-click="toggleColumnVisibility(index)">'
                            + '<i class="fa m-r-10" ng-class="{\'fa-check-circle-o\': isColumnVisible(index), \'fa-circle-o\': !isColumnVisible(index) }"></i> {{ name }}'
                        + '</button>'
                    + '</div>'
                + '</span>',
            scope: {
                tableId: '@',
                table: '=',
                columns: '=',
                class: '@'
            },
            link: function (scope, element, attrs) {
                var columnsListVisible = false;

                var init = function() {
                    if (!scope.table) {
                        setTimeout(init, 100);
                        return;
                    }

                    initLocalStorage(scope.tableId, scope.columns);

                    scope.$watch('table', scope.updateColumns);

                    $rootScope.$on('datatable.updated', function() {
                        setTimeout(function() {
                            scope.updateColumns();
                            scope.$apply();
                        }, 100);
                    });

                    if (!initialized) {
                        $(window).click(function () {
                            if (columnsListVisible) {
                                columnsListVisible = false;
                                scope.$apply();
                            }
                        });

                        initialized = true;
                    }
                };

                scope.toggleColumnsList = function($event) {
                    $event.stopPropagation();
                    columnsListVisible = !columnsListVisible;
                };

                scope.isColumnsListVisible = function() {
                    return columnsListVisible;
                };

                scope.toggleColumnVisibility = function(index) {
                    var column = scope.table.column(index);
                    var visible = !column.visible();

                    var storage = getStorage();
                    storage[scope.tableId][index] = visible ? 1 : 0;
                    setStorage(storage);

                    column.visible(visible);
                };

                scope.setColumnVisibility = function(index, visible) {
                    var column = scope.table.column(index);

                    var storage = getStorage();
                    storage[scope.tableId][index] = visible ? 1 : 0;
                    setStorage(storage);

                    if (column.visible() != visible) {
                        column.visible(visible);
                    }
                };

                scope.isColumnVisible = function(index) {
                    return scope.table ? scope.table.column(index).visible() : false;
                };

                scope.updateColumns = function() {
                    var storage = getStorage();

                    angular.forEach(scope.columns, function(name, index) {
                        scope.setColumnVisibility(index, storage[scope.tableId][index]);
                    });
                };

                scope.onPopupClick = function($event) {
                    $event.stopPropagation();
                };

                setTimeout(init, 100);
            }
        }
    }]);
